<!--
 * @Author: your name
 * @Date: 2020-09-10 19:34:52
 * @LastEditTime: 2022-10-31 15:25:36
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ConcreteCloud.Mobile\src\views\salesTerminal\contractInfo\contractAchrives\payedLog.vue
-->
<template>
    <div class="payedLog">
        <div class="top">
            <div class="con">
                <div class="contract-number">
                    合同编号：{{ contractInfo.contract_number }}
                </div>
                <div class="customer-name">
                    {{ contractInfo.engineering_name }}
                </div>
                <div class="project-name">
                    {{ contractInfo.client_name }}
                </div>
            </div>
        </div>
        <div class="axis-con">
            <div class="axis" v-if="payment.payment_list.length>0">
                <div class="row-item tit">
                    <div>
                        付款日期
                    </div>
                    <div>
                        付款金额
                    </div>
                </div>
                <div
                    class="row-item"
                    v-for="(item, index) in payment.payment_list"
                    :key="`pay_${index}`"
                >
                    <span class="time">
                        {{ item.receipt_date }}
                        <div class="dot-con">
                            <div class="dot"></div>
                            <div class="circle"></div>
                        </div>
                    </span>
                    <span class="account">{{ item.payment }}</span>
                </div>
            </div>
            <div v-else class="no-data"></div>
        </div>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        contractNumber: {
            type: String,
        },
        contractInfo: {
            type: Object,
        },
    },
    data() {
        return {
            payment: {
                payment_list: [],
            },
        };
    },
    watch: {
    },
    computed: {},
    created() {},
    mounted() {
        this.handleAccountList();
    },
    methods: {
        // 处理收款记录
        async handleAccountList() {
            const res = await this.getAccountList();
            if (res) {
                if (JSON.stringify(res) !== '{}') {
                    if (!res.payment_list) {
                        res.payment_list = [];
                    }
                    res.payment_list.map(item => {
                        if (item.receipt_date) {
                            item.receipt_date = item.receipt_date.substr(0, 10);
                        }
                    });
                    this.payment = res;
                }
            }
        },
        // 根据合同编号获取收款记录
        getAccountList() {
            const path = '/interfaceApi/sale/contract_archives/get_accounts_proceeds_list/' + this.contractNumber;
            return this.$axios.$get(path, { defEx: true });
        },

    },
};
</script>
<style lang="stylus">
.payedLog
    height 100%
    .top
        padding 15rpx
        background #2b5dab
        .con
            background #ffffff
            border-radius 4rpx
            padding 15rpx
            .contract-number
                font-size 16rpx
                color #3495FB
            .customer-name
                font-size 16rpx
                color #333333
                margin 5rpx 0
            .project-name
                font-size 14rpx
                color #666666
    .axis-con
        height calc(100% - 135rpx)
        overflow-y auto
        position: relative
        .axis
            height 100%
            position relative
            &:after
                top 0
                content ''
                height 100%
                position absolute
                left 50%
                width 1px
                background #D7D7D7
            .row-item
                display flex
                margin-bottom 30rpx
                .time
                    flex 1
                    text-align right
                    padding-right 20rpx
                    left 0
                    position relative
                    .dot-con
                        position absolute
                        right 0
                        top 0
                        z-index 10
                        .dot
                            width 10rpx
                            height 10rpx
                            background rgba(52,149,251,1)
                            border-radius 50%
                            position absolute
                            right -6rpx
                            top 5rpx
                        .circle
                            width 20rpx
                            height 20rpx
                            background rgba(52,149,251,0.1)
                            border-radius 50%
                            position absolute
                            right -11rpx
                .account
                    flex 1
                    text-align left
                    padding-left 20rpx
                    color #3394FA
            .tit
                padding-top 20rpx
                >div
                    flex 1
                    color #979EA7
                    &:first-child
                        text-align right
                        padding-right 20rpx
                    &:last-child
                        text-align left
                        padding-left 20rpx
</style>